const CAP9 = {
  id: "tokens-9",
  slug: "lenguajes-por-red-y-estandares-de-tokens",
  contentId: 9,
  title: "Lenguajes por Red y Estándares de Tokens",
  sections: [
    {
      id: "hero",
      heading: "Lenguajes por Red y Estándares de Tokens",
      text: `Esta sección resume, de forma práctica, en qué lenguaje se programan los contratos inteligentes
y qué estándares de token se usan en las principales blockchains. Está pensada como referencia rápida
para construir o auditar activos fungibles y no fungibles.`
    },

    {
      id: "redes-y-lenguajes",
      heading: "Redes principales y su lenguaje de contratos",
      list: [
        { title: "Ethereum (EVM)", text: "Solidity (y Vyper). Base de los estándares ERC; compila a bytecode EVM." },
        { title: "BNB Smart Chain (BSC)", text: "Solidity. Totalmente compatible con EVM (BEP-20 ≈ ERC-20)." },
        { title: "Polygon", text: "Solidity. Sidechain / capa compatible con EVM; contratos idénticos al entorno Ethereum." },
        { title: "Avalanche (C-Chain)", text: "Solidity. C-Chain es EVM; despliegue de ERC-20/721/1155 sin cambios." },
        { title: "Arbitrum / Optimism (L2)", text: "Solidity. Capa 2 de Ethereum; ejecutan bytecode EVM con compresión/optimización." },
        { title: "Solana", text: "Rust (también C/C++). Programas compilados a BPF; tokens vía SPL." },
        { title: "Flow", text: "Cadence. Lenguaje orientado a recursos; NFT y tokens como recursos seguros." },
        { title: "Algorand", text: "TEAL / PyTEAL. Contratos stateful/stateless; activos como ASA." },
        { title: "Cardano", text: "Plutus (basado en Haskell). UTXO extendido; políticas para tokens nativos." },
        { title: "Tezos", text: "Michelson / SmartPy / LIGO. Contratos formales; tokens FA1.2/FA2." },
        { title: "EOS / Telos", text: "C++. Contratos con EOSIO SDK; estándar eosio.token." },
        { title: "NEAR Protocol", text: "Rust / AssemblyScript. Tokens NEP-141 (fungibles) y NEP-171 (NFT)." },
        { title: "Tron", text: "Solidity. Compatible con EVM; estándares TRC-20/TRC-721." },
        { title: "Cosmos (CosmWasm)", text: "Rust. Contratos Wasm; tokens CW-20/CW-721." },
        { title: "Polkadot / Substrate", text: "Rust. Tokens vía pallets o smart-contracts en ink! (Wasm) y/o EVM pallet." },
        { title: "Hyperledger Fabric (permisionada)", text: "Go / JavaScript / Java. Chaincode empresarial; no usa estándares ERC." }
      ]
    },

    {
      id: "estandares-de-tokens",
      heading: "Estándares de token por ecosistema",
      list: [
        { title: "ERC-20 (EVM)", text: "Token fungible en Ethereum, Polygon, BSC, Avalanche, Arbitrum, Optimism. Lenguaje: Solidity." },
        { title: "ERC-721 (EVM)", text: "NFT (no fungible) clásico en EVM. Lenguaje: Solidity." },
        { title: "ERC-1155 (EVM)", text: "Multi-token: fungibles y no fungibles en un mismo contrato. Lenguaje: Solidity." },
        { title: "BEP-20 (BSC)", text: "Equivalente a ERC-20 en BNB Smart Chain. Lenguaje: Solidity." },
        { title: "TRC-20 / TRC-721 (Tron)", text: "Equivalentes a ERC-20/721 en Tron. Lenguaje: Solidity." },
        { title: "SPL Token (Solana)", text: "Estándar de tokens de Solana (fungibles y NFT). Lenguaje de programas: Rust." },
        { title: "ASA (Algorand Standard Asset)", text: "Activos estándar de Algorand. Lenguajes: TEAL / PyTEAL." },
        { title: "FA1.2 / FA2 (Tezos)", text: "Fungibles (FA1.2) y multi-activo (FA2). Lenguajes: Michelson / SmartPy / LIGO." },
        { title: "NEP-141 / NEP-171 (NEAR)", text: "Fungibles (141) y NFT (171). Lenguajes: Rust / AssemblyScript." },
        { title: "CW-20 / CW-721 (Cosmos + CosmWasm)", text: "Fungibles (CW-20) y NFT (CW-721) sobre Wasm. Lenguaje: Rust." },
        { title: "Ink! / Pallets (Substrate)", text: "Tokens definidos como pallets nativos o smart-contracts en ink!. Lenguaje: Rust." },
        { title: "eosio.token (EOS)", text: "Contrato básico de token fungible. Lenguaje: C++." }
      ]
    },

    {
      id: "interoperabilidad",
      heading: "Notas de interoperabilidad y despliegue",
      list: [
        { title: "Compatibilidad EVM", text: "Si tu contrato está en Solidity (ERC-20/721/1155), suele ser portable entre Ethereum, Polygon, BSC, Avalanche, Arbitrum y Optimism con cambios mínimos." },
        { title: "Lenguajes nativos no EVM", text: "Solana (Rust), Flow (Cadence), Algorand (TEAL) y NEAR (Rust/AS) requieren reescritura del contrato y adaptación de tooling." },
        { title: "Permisionadas", text: "En Fabric, los activos se gestionan con chaincode (Go/JS/Java) y modelos privados; no siguen ERC por diseño." }
      ]
    },

    {
      id: "conclusion",
      heading: "Conclusión",
      text: `Elegir red y estándar depende del caso de uso, el tooling disponible y los requisitos de escalabilidad y cumplimiento.
EVM aporta máxima reutilización (Solidity + ERC); Solana/Flow/Algorand/NEAR ofrecen modelos alternativos con ventajas específicas.
Este mapa de lenguajes y estándares te permite decidir con precisión dónde y cómo implementar tu token.`
    }
  ]
};

export default CAP9;
